module.exports = __webpack_public_path__ + "media/categories/9006-e7802ac9.svg";